/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popEarnTip.vue?vue&type=template&id=195568bb&scoped=true"
import script from "./popEarnTip.vue?vue&type=script&lang=js"
export * from "./popEarnTip.vue?vue&type=script&lang=js"
import style0 from "./popEarnTip.vue?vue&type=style&index=0&id=195568bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195568bb",
  null
  
)

export default component.exports